// Session-scoped flag: dismissing the unsupported-browser warning must not carry over to another

import { logger } from "./logging"

// inspection opened later on the same device. The desktop block is not dismissable at all.
const DISMISSED_KEY_PREFIX = "browserWarningDismissed:"

export function hasDismissedBrowserWarning(sessionId: string): boolean {
  try {
    return localStorage.getItem(DISMISSED_KEY_PREFIX + sessionId) === "1"
  } catch {
    return false
  }
}

export function markBrowserWarningDismissed(sessionId: string): void {
  try {
    localStorage.setItem(DISMISSED_KEY_PREFIX + sessionId, "1")
  } catch (error) {
    // Private mode / blocked storage — the user just gets the warning once more.
    logger.error(error, "markBrowserWarningDismissed failed")
  }
}
